__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "workflow-mfe";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@apollo/client", "3.10.5", () => (Promise.all([__webpack_require__.e(917), __webpack_require__.e(706), __webpack_require__.e(416), __webpack_require__.e(693)]).then(() => (() => (__webpack_require__(89917))))));
			register("ajv-errors", "3.0.0", () => (Promise.all([__webpack_require__.e(487), __webpack_require__.e(815), __webpack_require__.e(867), __webpack_require__.e(351)]).then(() => (() => (__webpack_require__(33351))))));
			register("ajv-formats", "2.1.1", () => (Promise.all([__webpack_require__.e(487), __webpack_require__.e(867), __webpack_require__.e(477)]).then(() => (() => (__webpack_require__(5477))))));
			register("ajv", "8.12.0", () => (Promise.all([__webpack_require__.e(487), __webpack_require__.e(815), __webpack_require__.e(581)]).then(() => (() => (__webpack_require__(1581))))));
			register("antd", "5.12.7", () => (Promise.all([__webpack_require__.e(122), __webpack_require__.e(773), __webpack_require__.e(416), __webpack_require__.e(51)]).then(() => (() => (__webpack_require__(48179))))));
			register("axios", "1.3.5", () => (__webpack_require__.e(476).then(() => (() => (__webpack_require__(8476))))));
			register("dagre", "0.8.5", () => (__webpack_require__.e(681).then(() => (() => (__webpack_require__(70681))))));
			register("detectincognitojs", "1.3.5", () => (__webpack_require__.e(637).then(() => (() => (__webpack_require__(88637))))));
			register("graphql", "16.6.0", () => (__webpack_require__.e(707).then(() => (() => (__webpack_require__(15707))))));
			register("js-cookie", "3.0.1", () => (__webpack_require__.e(258).then(() => (() => (__webpack_require__(6258))))));
			register("lodash", "4.17.21", () => (__webpack_require__.e(486).then(() => (() => (__webpack_require__(96486))))));
			register("lottie-react", "2.4.0", () => (Promise.all([__webpack_require__.e(260), __webpack_require__.e(416)]).then(() => (() => (__webpack_require__(69260))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(935), __webpack_require__.e(416)]).then(() => (() => (__webpack_require__(73935))))));
			register("react-helmet", "6.1.0", () => (Promise.all([__webpack_require__.e(593), __webpack_require__.e(416)]).then(() => (() => (__webpack_require__(64593))))));
			register("react-joyride", "2.5.4", () => (Promise.all([__webpack_require__.e(591), __webpack_require__.e(416), __webpack_require__.e(51)]).then(() => (() => (__webpack_require__(29591))))));
			register("react-json-view-lite", "1.3.0", () => (Promise.all([__webpack_require__.e(416), __webpack_require__.e(852)]).then(() => (() => (__webpack_require__(63852))))));
			register("react-router-dom", "6.9.0", () => (Promise.all([__webpack_require__.e(818), __webpack_require__.e(416)]).then(() => (() => (__webpack_require__(49818))))));
			register("react", "18.2.0", () => (__webpack_require__.e(294).then(() => (() => (__webpack_require__(67294))))));
			register("reactflow", "11.6.1", () => (Promise.all([__webpack_require__.e(666), __webpack_require__.e(416), __webpack_require__.e(51), __webpack_require__.e(517)]).then(() => (() => (__webpack_require__(1666))))));
			register("uuid", "9.0.1", () => (__webpack_require__.e(17).then(() => (() => (__webpack_require__(77017))))));
			register("zustand", "4.3.6", () => (Promise.all([__webpack_require__.e(416), __webpack_require__.e(986)]).then(() => (() => (__webpack_require__(27986))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};